// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"3d299c79","660":"8272f0e3"}[chunkId] + ".chunk.js";
};